import { Company, CompanyEnum } from '../models/company.model';
import { AccommodationTableLabels, CourseStartDatesTableLabels, ProductsWithPriceAndNoteLabels } from '../models/types';

export const getAccommodationsLabels = (company: Company): AccommodationTableLabels => {
  switch (company) {
    case CompanyEnum.KIL:
      return {
        title: 'Accommodation',
        type: 'Type',
        meals: 'Meals',
        bathroom: 'Bath',
        minAge: 'Min. age',
        price: 'Price',
      };
    case CompanyEnum.ALP:
      return {
        title: 'Accommodation',
        type: 'Type',
        meals: 'Meals',
        bathroom: 'Bath',
        minAge: 'Min. age',
      };
  }
};

export const getCourseStartDatesLabels = (company: Company): CourseStartDatesTableLabels => {
  switch (company) {
    case CompanyEnum.KIL:
      return {
        title: 'Course',
        startDates: 'Start date',
        courseLength: 'Length of course',
        courseBreak: 'Break',
      };
    case CompanyEnum.ALP:
      return {
        title: 'Course',
        startDates: 'Start date',
      };
  }
};

export const getKilTransferFeeLabels = (): ProductsWithPriceAndNoteLabels => {
  return {
    product: 'Destination',
    price: 'Price',
    notes: 'Notes',
  };
};

export const getGeneralFeesLabels = (): ProductsWithPriceAndNoteLabels => {
  return {
    product: 'Item',
    price: 'Price',
    notes: 'Notes',
  };
};

export const getStudentPreparationLabels = (): ProductsWithPriceAndNoteLabels => {
  return getDefaultProductsWithPriceAndNoteLabels();
};

export const getExamPreparationLabels = (): ProductsWithPriceAndNoteLabels => {
  return getDefaultProductsWithPriceAndNoteLabels();
};

export const getPathwayProgramFeesLabels = (): ProductsWithPriceAndNoteLabels => {
  return getDefaultProductsWithPriceAndNoteLabels();
};

export const prepareAsterisksFromNote = (noteIndex: number) => {
  let i = 0;
  let notationMark = '';
  while (i < noteIndex) {
    notationMark += '*';
    i++;
  }
  return notationMark;
};

/**
 * Generates a band string from min and max values.
 */
export const getBandFromMinMax = (min: number, max: number) => `${min}-${max}`;

const getDefaultProductsWithPriceAndNoteLabels = (): ProductsWithPriceAndNoteLabels => {
  return {
    product: 'Program Item',
    price: 'Fee',
    notes: 'Notes',
  };
};
